export default function ProjectCards({ projects }) {
  return (
    <div className="flex flex-col gap-2 mt-2">
      {projects.map((proj, i) => (
        <div
          key={i}
          className="bg-[#0f1120] border border-[#2a2d40] rounded-xl p-3"
        >
          <p className="text-xs font-medium text-white mb-1">{proj.title}</p>
          <p className="text-xs text-[#9997a0] leading-relaxed">{proj.desc}</p>
        </div>
      ))}
    </div>
  );
}